import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const SilverMedal: FunctionalComponent<IIconProps> = ({ width = '10', height = '10', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 3.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zM2 9.733V6.646A3.99 3.99 0 0 0 5 8a3.99 3.99 0 0 0 3-1.354v3.087c0 .162-.127.233-.279.258a.497.497 0 0 1-.268-.043l-2.115-.882a.88.88 0 0 0-.676 0l-2.115.882a.497.497 0 0 1-.268.043C2.127 9.966 2 9.895 2 9.733z"
        fill={fill}
      />
    </svg>
  );
};

export default SilverMedal;
